import { Tooltip, IconButton, Grid } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiInput from "components/SuiInput";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import DataTable from "custom/Tables/DataTable";
import MessageTypes from "enums/message-types";
import { FunnelSimple, Pencil } from "phosphor-react";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { removeMessage } from "redux/actions/message";
import { startAllOrganizationsScreen, ALL_ORGANIZATIONS } from "redux/actions/pages/organization";

import Swal from "sweetalert2";

const OrganizationList = ({
  message,
  localizations,
  allOrganizations,
  startScreen,
  removeErrorMsg,
  language,
}) => {
  const [organizationFilter, setOrganizationFilter] = useState("");
  const history = useHistory();

  useEffect(() => startScreen(), []);

  useEffect(() => {
    if (
      message &&
      message.messageContent !== undefined &&
      message.messageContent !== null &&
      message.messageContent !== ""
    ) {
      Swal.fire({
        icon: message.messageType || "error",
        title:
          message.messageType === MessageTypes.success
            ? localizations?.MESSAGE_SUCCESS ?? "BAŞARILI!"
            : localizations?.MESSAGE_ERROR ?? "HATA!",
        text: message.messageContent,
        showCancelButton: false,
        confirmButtonText: localizations?.MESSAGE_GO_HOME_CONFIRM_BTN,
      }).then((result) => {
        removeErrorMsg(ALL_ORGANIZATIONS);
        if (result.isConfirmed) {
          history.push("/");
        }
      });
    }
    // eslint-disable-next-line
  }, [message]);

  const columns = [
    {
      Header: localizations?.ORGANIZATION ?? "Organizasyon",
      accessor: "organization",
    },
    {
      Header: localizations?.PHONICS_ENABLED ?? "Phonics Erişimi",
      accessor: "phonicsEnabled",
    },
    {
      Header: localizations?.ACTIONS ?? "Actions",
      accessor: "preview",
      // eslint-disable-next-line react/prop-types
      Cell: ({ value: [data] }) => (
        <SuiBox mx={1} display="flex">
          <Tooltip title={localizations?.EDIT ?? "Düzenle"} placement="bottom">
            <IconButton
              aria-label={localizations?.EDIT}
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: "/organization/edit",
                  state: { organizationId: data.id },
                });
              }}
            >
              <Pencil size={32} weight="duotone" color="#7493b6" />
            </IconButton>
          </Tooltip>
        </SuiBox>
      ),
    },
  ];

  const getDataTableData = (organizationList, filter, lang) => ({
    columns,
    rows:
      organizationList && organizationList.length > 0
        ? organizationList
            .filter((o) => {
              let lowercaseFilter = "";
              if (filter && filter !== "") {
                lowercaseFilter = filter.toLocaleLowerCase(lang);
              }
              return o.organizationKey.toLocaleLowerCase(lang).includes(lowercaseFilter);
            })
            .map((o) => ({
              organization: o.organizationKey,
              phonicsEnabled: o.isPhonicsEnabled
                ? localizations?.YES ?? "Evet"
                : localizations?.NO ?? "Hayır",
              preview: [{ id: o.id }],
            }))
        : [],
  });

  const memoizedTableData = useMemo(
    () => getDataTableData(allOrganizations, organizationFilter, language),
    [organizationFilter, allOrganizations, language]
  );

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox py={3}>
          <Grid container>
            <Grid item sm={7} xs={12}>
              <h3>{localizations?.ORGANIZATION_LIST_HEADER ?? "Organizasyon Listesi"}</h3>
            </Grid>
            <Grid item sm={5} xs={12}>
              <SuiInput
                size="small"
                type="search"
                placeholder={localizations?.ORGANIZATION_FILTER_INPUT_PLACEHOLDER ?? "Kurum Ara..."}
                icon={{ component: <FunnelSimple />, direction: "left" }}
                value={organizationFilter}
                onChange={(e) => setOrganizationFilter(e.target.value)}
              />
            </Grid>
            <Grid item lg={12} xs={12} mt={3}>
              <DataTable
                table={memoizedTableData}
                entriesPerPage={{ defaultValue: 5, entries: [5, 10, 25, 50] }}
                pagination={{ variant: "contained", color: "dark" }}
              />
            </Grid>
          </Grid>
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

OrganizationList.defaultProps = {
  allOrganizations: [],
  message: null,
  localizations: null,
  language: "TR",
};

OrganizationList.propTypes = {
  allOrganizations: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  message: PropTypes.objectOf(PropTypes.any),
  localizations: PropTypes.objectOf(PropTypes.any),
  startScreen: PropTypes.func.isRequired,
  removeErrorMsg: PropTypes.func.isRequired,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  allOrganizations: state?.data?.organizations ? Object.values(state?.data?.organizations) : [],
  message: state.message[ALL_ORGANIZATIONS],
  localizations: state.localization.pairs,
  language: state.localization.language ?? "TR",
});

const mapDispatchToProps = {
  startScreen: startAllOrganizationsScreen,
  removeErrorMsg: removeMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationList);
